import React from 'react'
import './Narcissism.scss'

export const Narcissism = () => {
  return (
    <div className="narcissism-main-section">
      <div className="main-heading">
        <div className="first">Some things about me</div>
        <div className="second">(Narcissism time)</div>
      </div>
      <ul className="bullet-points">
        <li className="bullet-point">
          Love my looks a little too much <span className="make-bold">(well I can’t be blamed)</span>
        </li>
        <li className="bullet-point">
          Love to read and write <span className="make-bold"> ( I got 98 in english bro)</span>
        </li>
        <li className="bullet-point">I love baby pink on cars <span className="make-bold">( tf )</span></li>
        <li className="bullet-point">
          Can make people fall for me with just a smile
        </li>
        <li className="bullet-point">I have more kinks than my horse</li>
        <li className="bullet-point">
          I used to have green hair but I removed it cuz my horse liked it
        </li>
        <li className="bullet-point">
          If I had to choose between Mr. Darcy and Damon, I would choose my
          cheval.
        </li>
      </ul>
    </div>
  )
}
